import React from "react";
import ClassNames from "classnames";

var Subpage = function Subpage(_ref) {
  var slug = _ref.slug,
      children = _ref.children,
      isActive = _ref.isActive;
  var classNames = ClassNames("subpage", {
    "subpage--active": isActive
  });
  return React.createElement("div", {
    className: classNames,
    id: slug
  }, children);
};

Subpage.defaultProps = {
  isActive: false
};
export default Subpage;